import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuthorityStatusList as getAuthorityStatusListApi } from '../../helpers/authority_status/api_helper';

export const getAuthorityStatusList = createAsyncThunk(
    'authorityStatus/getAuthorityStatusList',
    async params => {
        try {
            const response = await getAuthorityStatusListApi(params);
            return response.data || response;
        } catch (error) {
            toast.error('Error al obtener estados de autoridad.', { autoClose: 3000 });
            throw new Error(error);
        }
    }
);
